import { peelSnapshotBlock } from './ticketCampaignSnapshot';

function peelPrefix(
  details: string,
  prefix: string,
): { value: string | null; remaining: string } {
  const pattern = new RegExp(`^${prefix}: (.+)\\n\\n([\\s\\S]*)$`);
  const match = details.match(pattern);
  if (!match) {
    return { value: null, remaining: details };
  }
  return { value: match[1], remaining: match[2] };
}

export function formatTicketDetails(
  campaignName: string,
  details: string,
  issueTitle?: string,
): string {
  const parts: string[] = [];
  const campaign = campaignName.trim();
  const title = issueTitle?.trim();
  const issue = details.trim();

  if (campaign) parts.push(`Campaign: ${campaign}`);
  if (title) parts.push(`Issue: ${title}`);
  if (issue) parts.push(issue);

  return parts.join('\n\n');
}

export function parseTicketDetails(details: string): {
  campaignName: string | null;
  issueTitle: string | null;
  issueDetails: string;
} {
  const { remaining } = peelSnapshotBlock(details);
  const campaign = peelPrefix(remaining, 'Campaign');
  const issue = peelPrefix(campaign.remaining, 'Issue');

  return {
    campaignName: campaign.value,
    issueTitle: issue.value,
    issueDetails: issue.remaining,
  };
}

const DRAFT_CACHE_PREFIX = 'ctvbuyer.selfservice.draft.';

function readDraftFormField(slug: string, field: string): string {
  try {
    const raw = localStorage.getItem(`${DRAFT_CACHE_PREFIX}${slug}.cache`);
    if (!raw) return '';
    const parsed = JSON.parse(raw) as { formData?: Record<string, unknown> };
    const value = parsed.formData?.[field];
    return typeof value === 'string' ? value : '';
  } catch {
    return '';
  }
}

export function readDraftCampaignName(slug: string): string {
  return readDraftFormField(slug, 'campaignName');
}

export function readDraftContactName(slug: string): string {
  return readDraftFormField(slug, 'contactName');
}

export function ticketListIssueName(ticket: {
  category: string;
  categoryLabel: string;
  details: string;
}): string {
  const { issueTitle } = parseTicketDetails(ticket.details);
  if (ticket.category === 'other') {
    return issueTitle ?? 'Other';
  }
  return ticket.categoryLabel;
}

export function ticketListCampaignName(details: string): string | null {
  return parseTicketDetails(details).campaignName;
}
